import React from 'react';
import PropTypes from 'prop-types';
import {
  Menu,
  MenuItem,
  Typography,
  Box,
  Stack,
  IconButton,
  CircularProgress,
} from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  PlayArrow as ApplyIcon,
} from '@mui/icons-material';

const SavedFiltersMenu = ({
  anchorEl,
  open,
  onClose,
  customFilters,
  isFilterLoading,
  onLoadFilter,
  onDeleteFilter,
  onApplyFilter,
}) => {
  const renderMenuContent = () => {
    if (isFilterLoading) {
      return (
        <MenuItem disabled>
          <CircularProgress size={20} sx={{ mr: 1 }} />
          Loading filters...
        </MenuItem>
      );
    }    if (customFilters.length > 0) {
      return customFilters.map((filter) => (
        <MenuItem key={filter._id} sx={{ flexDirection: 'column', alignItems: 'stretch' }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
            <Box>
              <Typography variant="subtitle2">{filter.name}</Typography>
              {filter.description && (
                <Typography variant="caption" color="text.secondary">
                  {filter.description}
                </Typography>
              )}
            </Box>
            <Stack direction="row" spacing={0.5}>              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onApplyFilter(filter);
                }}
                color="primary"
                title="Apply this filter (will replace any currently applied filter)"
              >
                <ApplyIcon fontSize="small" />
              </IconButton>              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onLoadFilter(filter);
                  onClose();
                }}
                title="Load filter for editing"
              >
                <EditIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteFilter(filter._id);
                }}
                color="error"
                title="Delete Filter"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Box>
        </MenuItem>
      ));
    }

    return <MenuItem disabled>No saved filters found</MenuItem>;
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { maxHeight: 400, width: 300 } }}
    >
      {renderMenuContent()}
    </Menu>
  );
};

SavedFiltersMenu.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  customFilters: PropTypes.array.isRequired,
  isFilterLoading: PropTypes.bool.isRequired,
  onLoadFilter: PropTypes.func.isRequired,
  onDeleteFilter: PropTypes.func.isRequired,
  onApplyFilter: PropTypes.func.isRequired,
};

export default SavedFiltersMenu;
